import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const REPORT_TYPES = {
   LOST_OR_DESTRUCTION: 'LOST_OR_DESTRUCTION',
   DAMAGE: 'DAMAGE',
} as const;

export const useReportTypeLabels = () => {
   const { t } = useTranslation();

   const REPORT_TYPE_LABELS = useMemo(
      () => ({
         [REPORT_TYPES.LOST_OR_DESTRUCTION]: t('report_type.lost_or_destruction'),
         [REPORT_TYPES.DAMAGE]: t('edit_pallets.table.damaged'),
      }),
      [t],
   );

   return { REPORT_TYPE_LABELS };
};
